import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

// 获取浏览器首选语言函数（兼容所有浏览器）
function getBrowserLang() {
  const navLang = navigator.language || navigator.userLanguage || navigator.browserLanguage
  // 截取前缀 zh / en
  const prefix = navLang.split('-')[0]
  // 只区分中英文，其他语言一律默认英文
  return prefix === 'zh' ? 'zh' : 'en'
}

const i18n = new VueI18n({
  // 优先级：本地缓存 > 浏览器语言 > 默认中文
  locale: localStorage.getItem('lang') || getBrowserLang(),
  messages: {
    zh,
    en
  }
})

export default i18n